(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.transparent = this.hasAttribute("data-transparent");
      this.sticky = this.hasAttribute("data-sticky");
      this.selectors = {
        announcementBar: ".shopify-section-announcement-bar",
      };
      this.announcementBarheight = 0;

      this.transparent && document.body.classList.add('transparent-header')
    }

    connectedCallback() {
      this.setupDesktopHashNavLinks();

      ["scroll", "load", "resize"].forEach((event) =>
        window.addEventListener(event, (event) => {
          this.updateHeaderOffsetVariables();
          this.handleTransparent();
          this.checkOverflowSubmenus();
          if (this.transparent && event.type !== 'scroll') this.offsetMainContent();
        })
      );

      if (this.hasAttribute('data-design-mode') && this.transparent) {
        window.addEventListener('shopify:section:load', (event) => {
          document.querySelector('#MainContent').style.marginTop = 0;

          // delay until styles are loaded
          setTimeout(() => {
            this.offsetMainContent();
          }, 1000);
          return;
        })
      }

      if (!this.transparent) return;
      this.offsetMainContent();
    }

    setupDesktopHashNavLinks() {
      const desktopPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      const navItems = Array.from(this.querySelectorAll('.header__nav-item'));
      let pointerNavInteraction = false;

      const blurActiveElement = () => {
        if (document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }
      };

      const blurActiveElementInside = (element) => {
        const active = document.activeElement;
        if (active instanceof HTMLElement && element.contains(active)) {
          active.blur();
        }
      };

      navItems.forEach((item) => {
        item.addEventListener('mouseenter', () => {
          if (!desktopPointer.matches || !pointerNavInteraction) return;

          const active = document.activeElement;
          if (!(active instanceof HTMLElement) || item.contains(active)) return;

          const activeNavItem = active.closest('.header__nav-item');
          if (activeNavItem && this.contains(activeNavItem)) {
            active.blur();
          }
        });

        item.addEventListener('mouseleave', () => {
          if (!desktopPointer.matches || !pointerNavInteraction) return;
          blurActiveElementInside(item);
        });
      });

      const localizedRoot = '{{ routes.root_url }}'.replace(/\/$/, '');
      const hashPlaceholderHrefs = new Set(['#', `${localizedRoot}#`, `${localizedRoot}/#`, '/#']);
      const isHashPlaceholderLink = (link) => {
        const href = link.getAttribute('href') || '';
        return hashPlaceholderHrefs.has(href);
      };

      this.querySelectorAll('.header__nav-link, .header__megamenu a, .header__nav-dropdown-link').forEach((link) => {
        link.addEventListener('pointerdown', (event) => {
          if (!desktopPointer.matches || event.pointerType === 'touch') return;
          pointerNavInteraction = true;
          blurActiveElement();
        });

        link.addEventListener('keydown', () => {
          pointerNavInteraction = false;
        });

        link.addEventListener('click', (event) => {
          if (!desktopPointer.matches) return;

          if (isHashPlaceholderLink(link)) {
            event.preventDefault();
          }

          if (!pointerNavInteraction) return;
          link.blur();
          blurActiveElement();
        });
      });
    }

    offsetMainContent() {
      document.querySelector(
        "#MainContent"
      ).style.marginTop = `-${this.offsetHeight  * 0.1}rem`;
    }

    handleTransparent() {
      const transparentAndSticky = this.transparent && this.sticky
      if (!transparentAndSticky) return;
      this.classList.toggle(
        "is-transparent",
        window.scrollY <= this.announcementBarHeight
      );
    }

    updateHeaderOffsetVariables() {
      const announcementBar = document.querySelector(
        this.selectors.announcementBar
      );
      this.announcementBarHeight = announcementBar
        ? announcementBar.offsetHeight
        : 0;
      const headerHeight = this.transparent ? 0 : this.offsetHeight;
      const headerOffset = this.announcementBarHeight + headerHeight;
      // Header height regardless of whether it's transparent or not.
      const transparentHeaderOffset = this.announcementBarHeight + this.offsetHeight;

      document.documentElement.style.setProperty(
        "--header-offset",
        `${headerOffset * 0.1}rem`
      );

      document.documentElement.style.setProperty(
        "--header-offset-with-transparent",
        `${transparentHeaderOffset * 0.1}rem`
      );

      const headerBottomPosition = this.getBoundingClientRect().bottom * 0.1;
      document.documentElement.style.setProperty(
        "--header-dropdown-max-height",
        `calc(100vmin - ${headerBottomPosition}rem)`
      );
    }

    checkOverflowSubmenus() {
      const containerBounderie =
        this.querySelector('[data-container]').getBoundingClientRect().width;

      this.querySelectorAll('[data-nav-sublinks]').forEach(submenu => {
        const dropdown = submenu.closest('[data-nav-dropdown]');
        const parentItem = submenu.closest('.header__nav-links-item');

        dropdown.classList.remove('is-overflowing');

        if (parentItem) {
          submenu.style.top = `${-parentItem.offsetTop}px`;
        }

        const [submenuLeft, submenuRight] = [
          submenu.getBoundingClientRect().left,
          submenu.getBoundingClientRect().right
        ];
        const submenuIsOverflowing =
          submenuLeft > containerBounderie || submenuRight > containerBounderie;
        if (submenuIsOverflowing) {
          dropdown.classList.add('is-overflowing')
        }
      })
    }
  }

  customElements.define("sticky-header", StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
